export default class Sentence {
  sentence: string;
  transition: string;

  constructor(sentence: string, trasition: string) {
    this.sentence = sentence;
    this.transition = trasition;
  }

  static fromJson(json: any): Sentence {
    const example = json.example;
    let sentence: string;
    let translation: string;

    if (example !== undefined) {
      sentence = example.sentence ?? example.responseSentence ?? "";
      translation = example.translation ?? example.responseTranslation ?? "";
    } else {
      sentence = json.sentence ?? json.responseSentence ?? "";
      translation = json.translation ?? json.responseTranslation ?? "";
    }

    return new Sentence(sentence, translation);
  }
}
